import { render, staticRenderFns } from "./ProductCommentEdit.vue?vue&type=template&id=535e4b54&scoped=true&"
import script from "./ProductCommentEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e4b54",
  null
  
)

export default component.exports